<template>
    <div class="card card-basic card--blue ">
        <div class="card__image position-relative" :style="profileImage">
            <span v-if="cardData.imageUrl == null" class="card__initials">{{
                cardData.initials
            }}</span>
        </div>
        <div class="card__text">
            <div class="card__text__top mx-auto">
                <h2>{{ cardData.name }}</h2>
                <ul class="mb-2 list-unstyled card__list font-italic">
                    <li>
                        {{ cardData.company }}
                    </li>
                    <li>
                        {{ cardData.position }}
                    </li>
                    <li>
                        <a :href="'mailto:' + cardData.email">{{
                            cardData.email
                        }}</a>
                    </li>
                    <li>
                        {{ cardData.phone }}
                    </li>
                </ul>
            </div>
        </div>
        <div
            v-if="cardData.groups || cardData.topics"
            class="card__bottom bg--blue align-self-end"
        >
            <div v-collapse-content>
                <h3 class="color--white font-italic mt-3 position-relative">
                    {{ readMoreHeading }}
                </h3>
                <ul v-if="cardData.groups" class="list-unstyled p-0">
                    <li v-for="group in cardData.groups" :key="group.Ids">
                        <a class="color--white" :href="group.url">
                            {{ group.name }}
                        </a>
                    </li>
                </ul>
                <ul v-if="cardData.topics" class="list-unstyled p-0">
                    <li v-for="topic in cardData.topics" :key="topic.Ids">
                        {{ topic.name }}
                    </li>
                </ul>
            </div>
            <div v-collapse-toggle class="card__bottom__button">
                <div
                    class="card__bottom__button__content d-block w-100 position-relative"
                >
                    <span class="card__bottom__read-more">Meer</span
                    ><span
                        class="icon-angle-down card__bottom__button__content__icon"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cardData: {
            type: Object,
            default() {
                return {};
            }
        },
        readMore: {
            type: [Object, String],
            default() {
                return null;
            }
        }
    },

    computed: {
        readMoreHeading() {
            if (typeof this.readMore === 'object') {
                return this.readMore.groups;
            } else {
                return this.readMore;
            }
        },
        profileImage() {
            return [
                this.cardData.imageUrl == null
                    ? {
                          'background-color': '#F5F4F5'
                      }
                    : {
                          'background-image':
                              'url(' + this.cardData.imageUrl + ')'
                      }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/scss/helpers/_extensions.scss';

a .card:hover {
    transform: none;
    @extend %box-shadow;
}

a .card:hover .card__bottom__button {
    height: auto;
}

.card {
    display: flex;
    flex-direction: column;
}

.card__image {
    height: 160px;
    width: 160px;
    margin: 20px auto 0 auto;
    background-size: cover;
    background-position: center center;
    border-radius: 90px;
}

.card__text {
    padding: 0 10px 0 10px;
    min-height: 200px;
}

.card__text__top {
    max-width: 75%;
}

.card__text__top h2 {
    font-family: $menu-font-family;
}

.card__bottom {
    position: relative;
    background: none;
    padding: 6px 15px 6px 30px;
}

.card__bottom h3 {
    font-family: $font-family-sans-serif;
    font-size: 1.25rem;
    z-index: 10;
}

.card__bottom__button {
    height: auto;
    background: none;
    padding: 0;
}

.card__bottom__button__content {
    opacity: 1;
}

.card__bottom__button__content__icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 30px;
}

.v-collapse-content {
    max-height: 0;
    -webkit-transition: max-height 0.3s ease-out;
    transition: max-height 0.3s ease-out;
    overflow: hidden;
    padding: 0;
}

.v-collapse-content h3 {
    pointer-events: none;
}

.v-collapse-content h3,
.v-collapse-content ul {
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    opacity: 0;
}

.v-collapse-content-end {
    -webkit-transition: max-height 0.3s ease-in;
    transition: max-height 0.3s ease-in;
    max-height: 500px;
}

.v-collapse-content-end h3,
.v-collapse-content-end ul {
    opacity: 1;
}

.v-collapse-content-end + .card__bottom__button {
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    height: 50px;
}

.v-collapse-content-end + .card__bottom__button .card__bottom__read-more {
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    opacity: 0;
    padding-left: 30px;
}

.v-collapse-content-end
    + .card__bottom__button
    .card__bottom__button__content__icon {
    right: 15px;
    -webkit-transform: translateY(-50%) rotate(180deg);
    transform: translateY(-50%) rotate(180deg);
}
</style>
